<template>
    <ClientModal />
    <div class="main-content">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>
        <transition name="fade">
            <div v-if="loadingGed" class="upload-overlay">
                <div class="upload-card shadow-lg text-center p-5 rounded-4 bg-white">
                    <div class="upload-animation mb-4">
                        <div class="spinner-growth text-primary" role="status"></div>
                        <div class="spinner-growth text-primary-emphasis" role="status" style="animation-delay: 0.2s">
                        </div>
                        <div class="spinner-growth text-primary" role="status" style="animation-delay: 0.4s"></div>
                    </div>

                    <h4 class="fw-bold text-dark mb-2">Processando Documentos</h4>
                    <p class="text-muted mb-4">Por favor, não feche a aba ou atualize a página.</p>

                    <div class="progress-container mb-3">
                        <div class="d-flex justify-content-between mb-2">
                            <span class="small fw-bold text-primary">{{ uploadStats.sent }} de {{ uploadStats.total }}
                                arquivos</span>
                            <span class="small fw-bold text-muted">{{ uploadStats.percentage }}%</span>
                        </div>
                        <div class="progress" style="height: 12px; border-radius: 10px;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                :style="{ width: uploadStats.percentage + '%' }"></div>
                        </div>
                    </div>

                    <div class="text-secondary small italic">
                        Enviando: <span class="fw-medium">{{ uploadStats.currentFileName }}</span>
                    </div>
                </div>
            </div>
        </transition>
        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"> <router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Clientes</li>
                </ol>
            </nav>
        </header>
        <div class="row g-3 mb-4">
            <div class="col-xl-3 col-md-6">
                <div class="card border-0 shadow-sm h-100 bg-white">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 bg-pmg-light p-3 rounded-3">
                                <i class="bi bi-people-fill fs-4 text-primary"></i>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="text-muted small mb-1">Total de Clientes</h6>
                                <h4 class="mb-0 fw-bold">{{ stats.total }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6">
                <div class="card border-0 shadow-sm h-100 bg-white">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 bg-success-light p-3 rounded-3">
                                <i class="bi bi-person-plus-fill fs-4 text-success"></i>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="text-muted small mb-1">Novos (Mês Atual)</h6>
                                <h4 class="mb-0 fw-bold">{{ stats.new_month }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6">
                <div class="card border-0 shadow-sm h-100 bg-white">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 bg-danger-light p-3 rounded-3">
                                <i class="bi bi-exclamation-octagon-fill fs-4 text-danger"></i>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="text-muted small mb-1">Inadimplentes</h6>
                                <h4 class="mb-0 fw-bold">{{ stats.defaulters }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6">
                <div class="card border-0 shadow-sm h-100 bg-white">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 bg-warning-light p-3 rounded-3">
                                <i class="bi bi-cash-coin fs-4 text-warning"></i>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="text-muted small mb-1">Crédito Total</h6>
                                <h4 class="mb-0 fw-bold">R$ {{ formatMoney(stats.total_credit) }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div
                class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4">
                <div class="flex-shrink-0">
                    <h4 class="mb-0 fw-bold">Clientes</h4>
                    <span class="text-muted fs-7 text-nowrap">Exibindo {{ clients.length }} de {{ totalItems }}</span>
                </div>

                <div
                    class="d-flex flex-wrap gap-2 align-items-center w-100 w-md-auto justify-content-start justify-content-md-end">

                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="flex-fill flex-md-grow-0">
                            <button class="btn btn-pmg-danger btn-sm px-3 w-100" @click="confirmDelete(null, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{ selectedIds.length }})
                            </button>
                        </div>
                    </transition>

                    <div class="dropdown me-2 pe-3 border-end">
                        <button class="btn btn-pmg-light dropdown-toggle w-100" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-printer me-1"></i> Relatórios / Ferramentas
                        </button>
                        <ul class="dropdown-menu shadow border-0 py-2 w-100">
                            <li>
                                <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Exportar Dados</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('pdf')">
                                    <i class="bi bi-file-earmark-pdf text-danger me-2"></i> Relatório Geral (PDF)
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('xlsx')">
                                    <i class="bi bi-file-earmark-excel text-success me-2"></i> Planilha Completa (Excel)
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider opacity-10">
                            </li>
                            <li>
                                <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Ferramentas</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openImportModal">
                                    <i class="bi bi-cloud-arrow-up text-primary me-2"></i> Importar Clientes
                                </a>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-pmg-light" @click="refreshData" :disabled="loading" title="Atualizar tela">
                        <i class="bi bi-arrow-clockwise" :class="{ 'spin-animation': loading }"></i>
                    </button>
                    <button class="btn btn-pmg-light flex-fill flex-md-grow-0" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <button class="btn btn-pmg-primary" @click="openModal('create')">
                        <i class="bi bi-plus-lg me-1"></i> Novo cliente
                    </button>

                </div>
            </div>

            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Pesquisa Geral</label>
                            <input v-model="filter.search" type="text" class="form-control form-control-pmg"
                                placeholder="Nome, documento, e-mail ou telefone...">
                        </div>

                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Empresa</label>
                            <select v-model="filter.branch_id" class="form-select form-control-pmg">
                                <option value="">Todas as Empresas</option>
                                <option v-for="branch in branchesList" :key="branch.id" :value="branch.id">
                                    {{ branch.name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Score Mínimo</label>
                            <input type="number" v-model="filter.score_min" min="0" max="1000"
                                class="form-control form-control-pmg" placeholder="0">
                        </div>

                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Score Máximo</label>
                            <input type="number" v-model="filter.score_max" min="0" max="1000"
                                class="form-control form-control-pmg" placeholder="1000">
                        </div>

                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Limite Mínimo (R$)</label>
                            <input type="text" v-model="filter.credit_min" @input="maskCurrencyMin"
                                class="form-control form-control-pmg" placeholder="0,00">
                        </div>

                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Limite Máximo (R$)</label>
                            <input type="text" v-model="filter.credit_max" @input="maskCurrencyMax"
                                class="form-control form-control-pmg" placeholder="0,00">
                        </div>

                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Empresas</label>
                            <select v-model="filter.branch_id" class="form-select form-control-pmg">
                                <option value="">Todas as Empresas</option>
                                <option v-for="branch in branchesList" :key="branch.id" :value="branch.id">
                                    {{ branch.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4 d-flex align-items-end">
                            <button class="btn btn-dark btn-pmg-dark fw-bold py-2 px-4" @click="applyFilter"
                                style="min-width: 150px;margin-right: 10px;">
                                <i class="bi bi-search me-2"></i> Filtrar
                            </button>
                            <button class="btn btn-outline-danger py-2 px-3 ml-5" @click="clearFilters"
                                title="Limpar Filtros">
                                <i class="bi bi-x-lg"></i> Limpar
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive" style="overflow-x: auto; width: 100%;">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%" class="text-center">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 30%">Cliente</th>
                            <th style="width: 15%">Documento</th>
                            <th style="width: 20%">Contato</th>
                            <th style="width: 10%">Score</th>
                            <th style="width: 10%">Limite</th>
                            <th style="width: 10%" class="text-center">Status</th>
                            <th style="width: 5%" class="text-end">Ações</th>
                        </tr>
                    </thead>
                    <tbody v-if="clients.length > 0">
                        <tr v-for="item in clients" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>
                            <td @click.prevent="openDetails(item)" class="pointer">
                                <div class="d-flex flex-column">
                                    <div class="d-flex align-items-center gap-2">
                                        <div class="fw-bold text-dark">{{ item.name }}</div>
                                        <span v-if="item.data_quality_analysis"
                                            v-tooltip="item.data_quality_analysis.observations"
                                            class="badge rounded-pill border fw-bold"
                                            :class="getQualityBadgeClass(item.data_quality_analysis.score)"
                                            style="font-size: 0.65rem; padding: 0.2rem 0.5rem; cursor: help;">

                                            <i class="bi bi-robot me-1"></i>
                                            {{ (item.data_quality_analysis.score * 100).toFixed(0) }}%
                                        </span>
                                    </div>

                                    <!-- Badges das Empresas Vinculadas -->
                                    <div v-if="item.branches && item.branches.length > 0"
                                        class="d-flex flex-wrap gap-1 mt-1">
                                        <span v-for="branch in item.branches" :key="branch.id"
                                            class="badge bg-light text-secondary border tiny">
                                            <i class="bi bi-building me-1"></i>{{ branch.name }}
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td>{{ item.document }}</td>
                            <td>
                                <div class="pmg-desc-cell">
                                    <div v-if="item.email" class="text-truncate small" style="max-width: 150px;">
                                        <i class="bi bi-envelope me-1"></i> {{ item.email }}
                                    </div>
                                    <div class="d-flex align-items-center gap-2">
                                        <i class="bi bi-telephone me-1"></i>
                                        <span class="small">{{ item.phone }}</span>

                                        <a v-if="item.phone"
                                            :href="'https://api.whatsapp.com/send?phone=55' + cleanPhone(item.phone) + '&text=Olá ' + item.name + ', tudo bem? Informamos que...'"
                                            target="_blank" class="btn-whatsapp-mini" title="Enviar WhatsApp">
                                            <i class="bi bi-whatsapp"></i>
                                        </a>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center gap-2">
                                    <div :class="'bg-' + item.score_color"
                                        style="width: 10px; height: 10px; border-radius: 50%;"></div>
                                    <span class="fw-bold small">{{ item.internal_score }}</span>
                                </div>
                            </td>
                            <td class="small fw-medium text-dark">
                                {{ item.credit_limit_formatted }}
                            </td>
                            <td class="text-center">
                                <span :class="{
                                    'badge bg-success-subtle text-success': item.status === 'ativo',
                                    'badge bg-danger-subtle text-danger': item.status === 'bloqueado',
                                    'badge bg-secondary-subtle text-secondary': item.status === 'inativo'
                                }" class="rounded-pill px-3 small fw-bold">
                                    {{ item.status }}
                                </span>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0 py-2">
                                        <li><a class="dropdown-item py-2" href="#" @click.prevent="openDetails(item)"><i
                                                    class="bi bi-eye me-2"></i> Detalhes</a></li>
                                        <li><a class="dropdown-item py-2" href="#" @click="openGedModal(item)"><i
                                                    class="bi bi-folder-fill me-2"></i> GED</a></li>
                                        <li><a class="dropdown-item py-2" href="#"
                                                @click.prevent="openModal('edit', item)"><i
                                                    class="bi bi-pencil me-2"></i> Editar</a></li>
                                        <li><a class="dropdown-item py-2 text-info" href="#"
                                                @click.prevent="confirmReanalyze(item)"><i class="bi bi-robot me-2"></i>
                                                Análise IA</a></li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li><a class="dropdown-item py-2 text-danger" href="#"
                                                @click.prevent="confirmDelete(item, false)"><i
                                                    class="bi bi-trash3 me-2"></i> Excluir</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <!-- Colspan ajustado para 8 (o total de colunas exato) -->
                            <td colspan="8" class="text-center py-5 text-muted">
                                <i class="bi bi-inbox fs-1 mb-2 opacity-50"></i><br>
                                <span>Nenhum cliente encontrado.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center mt-4" v-if="hasMore">
                <button class="btn btn-pmg-light px-5 btn-sm fw-bold" @click="loadMore" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    <span>{{ loading ? 'Carregando...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-exclamação-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">{{ isBulkDelete ? `Excluir ${selectedIds.length} cliente(s)
                            selecionado(s)?` : `Excluir "${itemToDelete?.nome || itemToDelete?.name}"?` }}</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalClientDetails" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-0">
                    <h4 class="fw-bold m-0 text-dark">Detalhes do Cliente</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="px-4 pt-3">
                    <ul class="nav nav-tabs nav-tabs-pmg" id="detailsTab" role="tablist">
                        <li class="nav-item">
                            <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab-info"
                                type="button">Detalhes</button>
                        </li>
                        <!-- <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-crm"
                                type="button">Interações (CRM)</button></li> -->
                        <li class="nav-item">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-audit"
                                type="button">Auditoria</button>
                        </li>
                    </ul>
                </div>

                <div class="modal-body px-4 py-4 custom-scrollbar" v-if="selectedClient">
                    <div class="tab-content">
                        <div v-if="selectedClient.data_quality_analysis" class="mb-4 border-bottom pb-4">
                            <div class="card border-0 shadow-sm bg-warning-subtle rounded-4 p-3">
                                <div class="d-flex align-items-center mb-2">
                                    <div class="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                                        style="width: 24px; height: 24px;">
                                        <i class="bi bi-robot" style="font-size: 0.8rem;"></i>
                                    </div>
                                    <h6 class="m-0 fw-bold text-dark" style="font-size: 0.85rem;">ASSISTENTE DE
                                        QUALIDADE</h6>
                                    <button @click="reanalyzeClient" class="btn btn-sm btn-link text-danger p-0 ms-2"
                                        :disabled="reanalyzing" title="Refazer análise agora">
                                        (<i class="bi bi-arrow-clockwise" :class="{ 'spin': reanalyzing }"></i>
                                        Reavaliar)
                                    </button>
                                    <span class="ms-auto badge rounded-pill fw-bold"
                                        :class="getScoreClass((selectedClient.data_quality_analysis.score * 100).toFixed(0))">
                                        Score: {{ (selectedClient.data_quality_analysis.score * 100).toFixed(0) }}%
                                    </span>
                                </div>

                                <p class="small text-dark mb-3 opacity-75">
                                    {{ selectedClient.data_quality_analysis.observations }}
                                </p>

                                <div class="row g-2">
                                    <div v-for="suggestion in activeSuggestions" :key="suggestion.field" class="col-12">
                                        <div
                                            class="bg-white p-2 rounded-3 border-start border-4 border-warning shadow-xs">
                                            <div class="d-flex align-items-center">
                                                <i class="bi bi-lightbulb-fill text-warning me-2 small"></i>
                                                <span class="fw-bold text-muted text-uppercase"
                                                    style="font-size: 0.65rem;">
                                                    Ajustar:
                                                </span>
                                            </div>
                                            <div class="small text-dark mt-1 ps-4">{{ suggestion.text }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade show active" id="tab-info" role="tabpanel">
                            <h6 class="text-uppercase text-muted fw-bold small mb-3 letter-spacing-1">Informações Gerais
                            </h6>
                            <div class="row g-3 mb-4">
                                <div class="col-md-7">
                                    <p class="text-muted small mb-1">Nome</p>
                                    <p class="fw-bold fs-5 mb-0 text-dark">{{ selectedClient.name }}</p>
                                </div>
                                <div class="col-md-5">
                                    <p class="text-muted small mb-1">Documento (CPF/CNPJ)</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.document }}</p>
                                </div>
                                <div class="col-md-4 mt-3">
                                    <p class="text-muted small mb-1">Telefone</p>
                                    <p class="fw-bold mb-0 text-success">{{ selectedClient.phone }}</p>
                                </div>
                                <div class="col-md-8 mt-3">
                                    <p class="text-muted small mb-1">E-mail</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.email || 'Não informado' }}</p>
                                </div>
                            </div>

                            <hr class="opacity-10 my-4">

                            <h6 class="text-uppercase text-muted fw-bold small mb-3 letter-spacing-1">Endereço Completo
                            </h6>
                            <div class="row g-3 mb-4">
                                <div class="col-md-9">
                                    <p class="text-muted small mb-1">Logradouro</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.address?.street || '-' }}</p>
                                </div>
                                <div class="col-md-3">
                                    <p class="text-muted small mb-1">CEP</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.address?.zip_code || '-' }}</p>
                                </div>
                                <div class="col-md-5 mt-3">
                                    <p class="text-muted small mb-1">Bairro</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.address?.neighborhood || '-' }}
                                    </p>
                                </div>
                                <div class="col-md-4 mt-3">
                                    <p class="text-muted small mb-1">Cidade</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.address?.city || '-' }}</p>
                                </div>
                                <div class="col-md-3 mt-3">
                                    <p class="text-muted small mb-1">Estado (UF)</p>
                                    <p class="fw-bold mb-0 text-dark text-uppercase">{{ selectedClient.address?.state ||
                                        '-' }}</p>
                                </div>
                            </div>

                            <hr class="opacity-10 my-4">

                            <h6 class="text-uppercase text-muted fw-bold small mb-3 letter-spacing-1">Empresas
                                Vinculadas
                            </h6>
                            <div v-if="selectedClient.branches && selectedClient.branches.length > 0"
                                class="row g-2 mb-4">
                                <div v-for="branch in selectedClient.branches" :key="branch.id" class="col-md-6">
                                    <div class="d-flex align-items-center p-2 border rounded bg-light">
                                        <i class="bi bi-building fs-5 text-secondary me-2"></i>
                                        <div>
                                            <div class="fw-bold small text-dark">{{ branch.name }}</div>
                                            <div class="tiny text-muted" v-if="branch.document">CNPJ/Doc: {{
                                                branch.document }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-muted small mb-4">
                                Nenhuma empresa vinculada a este cliente.
                            </div>

                            <hr class="opacity-10 my-4">

                            <h6 class="text-uppercase text-muted fw-bold small mb-3 letter-spacing-1">Dados Pessoais e
                                Documentação</h6>
                            <div class="row g-3 mb-4">
                                <div class="col-md-4">
                                    <p class="text-muted small mb-1">Estado Civil</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.personal_data.marital_status ||
                                        '-' }}</p>
                                </div>
                                <div class="col-md-4">
                                    <p class="text-muted small mb-1">Escolaridade</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.personal_data.education_level ||
                                        '-' }}</p>
                                </div>
                                <div class="col-md-4">
                                    <p class="text-muted small mb-1">Profissão</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.personal_data.occupation || '-'
                                        }}</p>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <p class="text-muted small mb-1">RG</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.extra_documents.id_document ||
                                        '-' }}</p>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <p class="text-muted small mb-1">CNH</p>
                                    <p class="fw-bold mb-0 text-dark">{{ selectedClient.extra_documents.driver_license
                                        || '-' }}</p>
                                </div>
                            </div>
                            <h6 class="text-uppercase text-muted fw-bold small mb-2 letter-spacing-1 mt-4">Empresas
                                Vinculadas</h6>
                            <div v-if="selectedClient && selectedClient.branches && selectedClient.branches.length > 0"
                                class="row g-2 mb-4">
                                <div v-for="branch in selectedClient.branches" :key="branch.id" class="col-md-6">
                                    <div class="d-flex align-items-center p-2 border rounded bg-light shadow-sm">
                                        <i class="bi bi-building fs-5 text-secondary me-2"></i>
                                        <div>
                                            <div class="fw-bold small text-dark">{{ branch.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-muted small mb-4">
                                Nenhuma empresa específica vinculada a este cliente.
                            </div>
                            <h6 class="text-uppercase text-muted fw-bold small mb-2 letter-spacing-1 mt-4">Observações
                            </h6>
                            <div class="bg-light rounded-3 p-3 border shadow-sm">
                                <p class="mb-0 text-secondary small" style="white-space: pre-line;">
                                    {{ selectedClient.notes || 'Nenhuma observação registrada.' }}
                                </p>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="tab-audit" role="tabpanel">
                            <div class="audit-timeline p-2">
                                <div v-for="act in selectedClient.activities" :key="act.id" class="audit-item mb-4">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="d-flex align-items-center">
                                            <div class="user-avatar-mini me-2">
                                                <i class="bi bi-person-circle fs-5 text-secondary"></i>
                                            </div>
                                            <div>
                                                <span class="fw-bold text-dark d-block line-height-1">{{ act.user
                                                    }}</span>
                                                <span class="badge-action mt-1" :class="getActionClass(act.action)">
                                                    {{ act.action_label || (act.action ? act.action.toUpperCase() :
                                                        'SISTEMA') }}
                                                </span>
                                            </div>
                                        </div>
                                        <span class="text-muted tiny fw-medium">{{ act.date }}</span>
                                    </div>

                                    <div v-if="act.changes && Object.keys(act.changes).length"
                                        class="audit-changes-card">
                                        <div v-for="(change, field) in act.changes" :key="field" class="change-row">
                                            <div class="change-label text-uppercase">{{ formatFieldName(field) }}</div>
                                            <div class="change-values d-flex align-items-center gap-2">
                                                <span class="old-value text-danger text-decoration-line-through">
                                                    {{ change.old || 'Nulo' }}
                                                </span>

                                                <i class="bi bi-arrow-right text-muted small"></i>

                                                <span class="new-value text-success fw-bold">
                                                    {{ change.new || change || 'Nulo' }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="!selectedClient.activities?.length" class="text-center py-5">
                                    <i class="bi bi-clock-history fs-1 text-light"></i>
                                    <p class="text-muted small mt-2">Nenhum registro de auditoria.</p>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="tab-crm" role="tabpanel">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h6 class="text-uppercase text-muted fw-bold small mb-0">Histórico de Contatos</h6>
                                <button class="btn btn-sm btn-pmg-primary py-1"
                                    @click="showOccurrenceForm = !showOccurrenceForm">
                                    <i class="bi bi-chat-left-dots me-1"></i> Registrar Contato
                                </button>
                            </div>

                            <div v-if="showOccurrenceForm" class="bg-light p-3 rounded-3 border mb-4 shadow-sm">
                                <div class="mb-2">
                                    <select v-model="newOccurrence.type" class="form-select form-select-sm mb-2">
                                        <option value="contato">Contato Comercial</option>
                                        <option value="cobranca">Cobrança</option>
                                        <option value="suporte">Suporte Técnico</option>
                                    </select>
                                    <textarea v-model="newOccurrence.description" class="form-control form-control-sm"
                                        rows="3" placeholder="Descreva o que foi conversado..."></textarea>
                                </div>
                                <div class="d-flex justify-content-end gap-2">
                                    <button class="btn btn-sm btn-light"
                                        @click="showOccurrenceForm = false">Cancelar</button>
                                    <button class="btn btn-sm btn-dark" @click="saveOccurrence">Salvar Registro</button>
                                </div>
                            </div>

                            <div class="crm-timeline">
                                <div v-for="occ in selectedClient.occurrences" :key="occ.id"
                                    class="p-3 border rounded-3 mb-2 bg-white shadow-xs">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <span class="badge bg-secondary-subtle text-secondary text-uppercase tiny">{{
                                            occ.type }}</span>
                                        <span class="tiny text-muted">{{ occ.date }}</span>
                                    </div>
                                    <p class="small text-dark mb-1">{{ occ.description }}</p>
                                    <div class="tiny text-muted italic">Registrado por: {{ occ.user }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0 p-4 pt-2">
                    <button class="btn btn-outline-light w-100 rounded-3 py-2 fw-medium text-muted border shadow-sm"
                        data-bs-dismiss="modal">
                        <i class="bi bi-x me-1"></i> Fechar Detalhes
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalDeleteDoc" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <h5 class="modal-title">Confirmar Exclusão</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body text-center py-4">
                    <i class="bi bi-exclamation-triangle text-danger fs-1 mb-3"></i>
                    <p class="mb-0">Deseja realmente excluir este documento do GED?</p>
                    <small class="text-muted">Esta operação é irreversível.</small>
                </div>
                <div class="modal-footer border-0">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-danger" @click="executeDocDeletion">Excluir Agora</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalGed" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-light">
                    <h5 class="modal-title">
                        <i class="bi bi-files me-2"></i>
                        GED - <span class="text-primary">{{ selectedClientGed?.name }}</span>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="upload-area p-4 border-2 border-dashed rounded text-center bg-light mb-4">
                        <input type="file" ref="fileInputGed" @change="handleFileSelectionGed" multiple class="d-none"
                            accept=".pdf,.jpg,.jpeg,.png">
                        <i class="bi bi-cloud-arrow-up fs-1 text-primary opacity-50"></i>
                        <p class="mt-2 small text-muted">Selecione novos documentos para este cliente</p>
                        <button type="button" class="btn btn-sm btn-primary" @click="$refs.fileInputGed.click()">
                            Selecionar Arquivos
                        </button>
                    </div>
                    <div class="mt-3" v-if="newGedFiles.length > 0">
                        <div v-for="(file, index) in newGedFiles" :key="'new-upload-' + index"
                            class="d-flex align-items-center p-2 mb-2 bg-white border-start border-3 border-primary rounded shadow-sm">

                            <i class="bi bi-file-earmark-arrow-up me-2 text-primary fs-5"></i>

                            <div class="flex-grow-1 overflow-hidden">
                                <div class="small fw-bold text-dark text-truncate">{{ file.name }}</div>
                                <div class="tiny text-muted">{{ (file.size / 1024).toFixed(1) }} KB</div>
                            </div>

                            <button type="button" @click="newGedFiles.splice(index, 1)" class="btn btn-sm text-danger">
                                <i class="bi bi-x-circle"></i>
                            </button>
                        </div>
                    </div>
                    <div v-if="selectedClientGed?.documents && selectedClientGed.documents.length > 0">
                        <h6 class="text-uppercase text-muted fw-bold small mb-3 mt-4">
                            <i class="bi bi-archive me-1"></i> Arquivos Armazenados
                        </h6>

                        <div class="row g-2">
                            <div v-for="doc in selectedClientGed.documents" :key="doc.id" class="col-md-6">
                                <div class="d-flex align-items-center p-2 border rounded shadow-sm bg-white">
                                    <i :class="getFileIcon(doc.file_type)" class="fs-4 me-2"></i>
                                    <div class="flex-grow-1 text-truncate">
                                        <div class="small fw-bold text-dark text-truncate">{{ doc.file_name }}</div>
                                        <div class="tiny text-muted">{{ doc.file_size }}</div>
                                    </div>
                                    <div class="d-flex gap-1">
                                        <button type="button" @click="viewDocument(doc)"
                                            class="btn btn-sm btn-light border" title="Ver">
                                            <i class="bi bi-eye"></i>
                                        </button>
                                        <button type="button" @click="downloadFile(doc)"
                                            class="btn btn-sm btn-light border text-primary" title="Baixar">
                                            <i class="bi bi-download"></i>
                                        </button>
                                        <button type="button" @click="confirmDeleteDoc(doc.id)"
                                            class="btn btn-sm btn-light border text-danger" title="Excluir">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="!newGedFiles.length" class="text-center py-5 opacity-50">
                        <i class="bi bi-folder2-open fs-1 d-block mb-2"></i>
                        <p class="small mb-0">Nenhum documento arquivado para este cliente.</p>
                    </div>
                    <hr v-if="newGedFiles.length && selectedClientGed?.documents?.length">
                </div>
                <div class="modal-footer bg-light">
                    <button type="button" class="btn btn-pmg-light" data-bs-dismiss="modal">Fechar</button>
                    <button type="button" class="btn-pmg-primary" @click="uploadGedFiles"
                        :disabled="!newGedFiles.length">
                        <span v-if="loadingGed" class="spinner-border spinner-border-sm me-1"></span>
                        Salvar Novos Arquivos
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalGeneralReport" tabindex="-1" aria-hidden="true" ref="modalGeneralReport">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <h5 class="fw-bold m-0 text-dark">Filtros do Relatório Geral de Clientes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body p-4">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Criado em</label>
                            <input type="date" v-model="reportFilters.start_date" class="form-control form-control-pmg">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Criado até</label>
                            <input type="date" v-model="reportFilters.end_date" class="form-control form-control-pmg">
                        </div>

                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Status do Cliente</label>
                            <select v-model="reportFilters.status" class="form-select form-control-pmg">
                                <option value="ALL">Todos os Status</option>
                                <option value="ativo">Apenas Ativos</option>
                                <option value="inativo">Apenas Inativos</option>
                                <option value="inadimplente">Apenas Inadimplentes</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Empresa</label>
                            <select v-model="reportFilters.branch_id" class="form-select form-control-pmg">
                                <option value="ALL">Todas as Empresas</option>
                                <option v-for="branch in branchesList" :key="branch.id" :value="branch.id">
                                    {{ branch.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Tipo de Pessoa</label>
                            <select v-model="reportFilters.person_type" class="form-select form-control-pmg">
                                <option value="ALL">Ambos (Física e Jurídica)</option>
                                <option value="FISICA">Pessoa Física</option>
                                <option value="JURIDICA">Pessoa Jurídica</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">UF / Estado</label>
                            <select v-model="reportFilters.state" class="form-select form-control-pmg">
                                <option value="ALL">Todos os Estados</option>
                                <option value="AC">Acre (AC)</option>
                                <option value="AL">Alagoas (AL)</option>
                                <option value="AP">Amapá (AP)</option>
                                <option value="AM">Amazonas (AM)</option>
                                <option value="BA">Bahia (BA)</option>
                                <option value="CE">Ceará (CE)</option>
                                <option value="DF">Distrito Federal (DF)</option>
                                <option value="ES">Espírito Santo (ES)</option>
                                <option value="GO">Goiás (GO)</option>
                                <option value="MA">Maranhão (MA)</option>
                                <option value="MT">Mato Grosso (MT)</option>
                                <option value="MS">Mato Grosso do Sul (MS)</option>
                                <option value="MG">Minas Gerais (MG)</option>
                                <option value="PA">Pará (PA)</option>
                                <option value="PB">Paraíba (PB)</option>
                                <option value="PR">Paraná (PR)</option>
                                <option value="PE">Pernambuco (PE)</option>
                                <option value="PI">Piauí (PI)</option>
                                <option value="RJ">Rio de Janeiro (RJ)</option>
                                <option value="RN">Rio Grande do Norte (RN)</option>
                                <option value="RS">Rio Grande do Sul (RS)</option>
                                <option value="RO">Rondônia (RO)</option>
                                <option value="RR">Roraima (RR)</option>
                                <option value="SC">Santa Catarina (SC)</option>
                                <option value="SP">São Paulo (SP)</option>
                                <option value="SE">Sergipe (SE)</option>
                                <option value="TO">Tocantins (TO)</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Cidade</label>
                            <select v-model="reportFilters.city" class="form-select form-control-pmg"
                                :disabled="reportFilters.state === 'ALL' || loadingCities">
                                <option value="ALL">Todas as Cidades</option>
                                <option v-for="city in cities" :key="city.id" :value="city.nome">
                                    {{ city.nome }}
                                </option>
                            </select>
                            <div v-if="loadingCities" class="form-text text-primary small mt-1">
                                <span class="spinner-border spinner-border-sm me-1"
                                    style="width: 0.8rem; height: 0.8rem;"></span>
                                Carregando cidades...
                            </div>
                        </div>
                    </div>
                    <hr class="my-4 text-muted">

                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="fw-bold text-dark m-0">Campos do Relatório (Mín. 2)</h6>

                        <div class="form-check form-switch m-0">
                            <input class="form-check-input cursor-pointer" type="checkbox" id="chk_selectAll"
                                v-model="selectAllFields">
                            <label class="form-check-label small fw-bold cursor-pointer" for="chk_selectAll">
                                Selecionar Todos
                            </label>
                        </div>
                    </div>

                    <div class="row g-2 mb-3">
                        <div class="col-md-3 col-sm-4" v-for="field in availableFields" :key="field.id">
                            <div class="form-check">
                                <input class="form-check-input cursor-pointer" type="checkbox" :value="field.id"
                                    :id="'chk_' + field.id" v-model="reportFilters.fields">
                                <label class="form-check-label small cursor-pointer" :for="'chk_' + field.id">
                                    {{ field.label }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5">
                        <button class="btn btn-pmg-primary w-100 py-3 fw-bold"
                            @click="exportFormat === 'pdf' ? downloadGeneralReport() : exportClientsExcel()"
                            :disabled="loadingReport || !isReportValid">
                            <template v-if="loadingReport">
                                <span class="spinner-border spinner-border-sm me-2"></span>
                                PROCESSANDO...
                            </template>
                            <template v-else>
                                <i :class="exportFormat === 'pdf' ? 'bi-file-earmark-pdf-fill' : 'bi-file-earmark-excel-fill'"
                                    class="me-2"></i>
                                {{ exportFormat === 'pdf' ? 'GERAR RELATÓRIO PDF' : 'EXPORTAR PLANILHA XLSX' }}
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalImportPreview" tabindex="-1" aria-hidden="true" ref="modalImportPreview">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4">
                    <h5 class="fw-bold m-0"><i
                            class="bi bi-file-earmark-arrow-up me-2 text-primary"></i>Pré-visualização da
                        Importação</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" @click="resetImport"></button>
                </div>

                <div class="modal-body p-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="text-muted small">Siga o padrão das colunas para evitar erros.</span>
                        <a href="#" @click.prevent="downloadImportTemplate"
                            class="btn btn-link btn-sm p-0 text-decoration-none">
                            <i class="bi bi-download me-1"></i> Baixar Planilha Exemplo
                        </a>
                    </div>
                    <div v-if="importDuplicates.length > 0" class="alert alert-danger border-0 shadow-sm mb-3">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-layers-half fs-4 me-3"></i>
                            <div>
                                <h6 class="fw-bold mb-1">Dados Duplicados na Planilha</h6>
                                <p class="small mb-0">
                                    Encontramos registros com o mesmo Documento ou E-mail nas linhas:
                                    <strong>{{importDuplicates.map(d => d.linha).join(', ')}}</strong>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="importErrors.length > 0" class="alert alert-warning border-0 shadow-sm mb-3">
                        <div class="d-flex">
                            <i class="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                            <div>
                                <h6 class="fw-bold mb-1">Atenção: {{ importErrors.length }} linha(s) com dados
                                    incompletos
                                </h6>
                                <p class="small mb-0 text-secondary">
                                    As seguintes linhas no Excel precisam de correção:
                                    <strong>{{importErrors.map(e => e.linha).join(', ')}}</strong>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="!importPreviewData.length"
                        class="upload-area p-5 border-2 border-dashed rounded text-center bg-light">
                        <input type="file" ref="fileInputImport" @change="handleFilePreview" class="d-none"
                            accept=".xlsx,.csv">
                        <i class="bi bi-file-earmark-excel fs-1 text-muted opacity-50"></i>
                        <p class="mt-3 mb-4">Selecione a planilha de clientes para análise</p>
                        <button class="btn btn-pmg-primary" @click="$refs.fileInputImport.click()">
                            Escolher Arquivo
                        </button>
                    </div>

                    <div v-else>
                        <div class="alert alert-info border-0 rounded-3 small">
                            <i class="bi bi-info-circle me-2"></i>
                            Encontramos <strong>{{ importPreviewData.length }}</strong> registros. Verifique se as
                            colunas
                            estão corretas antes de confirmar.
                        </div>

                        <div class="table-responsive rounded-3 border">
                            <div class="table-responsive rounded-3 border">
                                <div class="table-responsive rounded-3 border">
                                    <table class="table table-sm table-hover mb-0" style="min-width: 1000px;">
                                        <thead class="bg-light">
                                            <tr>
                                                <th class="small text-muted py-2 ps-3" style="width: 50px;">#</th>
                                                <th class="small text-muted py-2" style="width: 200px;">NOME</th>
                                                <th class="small text-muted py-2" style="width: 130px;">DOCUMENTO</th>
                                                <th class="small text-muted py-2">E-MAIL</th>
                                                <th class="small text-muted py-2" style="width: 120px;">TELEFONE</th>
                                                <th class="small text-muted py-2" style="width: 120px;">CIDADE/UF</th>
                                                <th class="small text-muted py-2 text-end" style="width: 100px;">LIMITE
                                                </th>
                                                <th class="small text-muted py-2 text-center" style="width: 70px;">SCORE
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in importPreviewData" :key="index"
                                                :class="{ 'table-danger-light': row.isInvalid }">
                                                <td class="ps-3 small text-muted">{{ row.excelRow }}</td>
                                                <td class="small fw-bold">
                                                    <div class="text-truncate" style="max-width: 190px;"
                                                        :title="row.nome">
                                                        <i v-if="row.isInvalid"
                                                            class="bi bi-exclamation-circle-fill text-danger me-1"></i>
                                                        {{ row.nome }}
                                                    </div>
                                                </td>
                                                <td class="small">{{ row.documento }}</td>
                                                <td class="small text-muted">
                                                    <div class="text-truncate" style="max-width: 150px;"
                                                        :title="row.email">
                                                        {{ row.email }}</div>
                                                </td>
                                                <td class="small">{{ row.telefone }}</td>
                                                <td class="small">{{ row.cidade }}/{{ row.uf }}</td>
                                                <td class="small text-end">R$ {{ row.limite }}</td>
                                                <td class="small text-center">
                                                    <span :class="row.score > 500 ? 'text-success' : 'text-warning'"
                                                        class="fw-bold">
                                                        {{ row.score }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer border-0 p-4 pt-0">
                    <button class="btn btn-pmg-light" data-bs-dismiss="modal" @click="resetImport">Cancelar</button>
                    <button class="btn btn-pmg-primary px-4" :disabled="!importPreviewData.length || loading"
                        @click="executeFinalImport">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                        Confirmar e Importar Clientes
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-if="showGedPreview" class="modal fade show d-block" style="background: rgba(0,0,0,0.7);">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Visualizando Documento</h5>
                    <button type="button" class="btn-close" @click="showGedPreview = false"></button>
                </div>
                <div class="modal-body text-center" v-if="activeDoc">
                    <vue-pdf-embed v-if="isPdf(activeDoc)" :source="activeDoc.url" />
                    <img v-else-if="isImage(activeDoc)" :src="activeDoc.url" class="img-fluid"
                        style="max-height: 70vh; object-fit: contain;" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="confirmReanalyzeModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                <div class="modal-body">
                    <div class="text-warning mb-3">
                        <i class="bi bi-robot fs-1"></i>
                    </div>
                    <h5 class="fw-bold">Reanálise IA</h5>
                    <p class="text-muted small">Deseja que a Inteligência Artificial reavalie os dados do cliente "{{
                        clientToReanalyze?.nome || clientToReanalyze?.name }}"?</p>
                </div>
                <div class="d-flex gap-2 justify-content-center pb-2">
                    <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-warning px-4 rounded-3 fw-bold text-dark" @click="executeReanalyze"
                        :disabled="reanalyzing">
                        <span v-if="reanalyzing" class="spinner-border spinner-border-sm me-2"></span> Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';
import * as XLSX from 'xlsx';
import VuePdfEmbed from 'vue-pdf-embed';
import { clientModalState } from '@/utils/clientModalState';
import ClientModal from '@/components/client/ClientModal.vue';

export default {
    inject: ['globalLoading'],
    components: { VuePdfEmbed, ClientModal },
    data() {
        return {
            clients: [], alerts: [], loading: false, isEditing: false, showFilter: false,
            filter: {
                search: '',
                branch_id: '',
                score_min: '',
                score_max: '',
                credit_min: '',
                credit_max: ''
            },
            branchesList: [],
            selectedIds: [],
            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            hasMore: false,
            form: {
                id: null, name: '', document: '', email: '', phone: '', status: 'active',
                zip_code: '', street: '', neighborhood: '', city: '', state: '',
                education_level: '', occupation: '', marital_status: '',
                id_document: '', driver_license: '', notes: '', documents: [],
                branch_ids: []
            },
            clientFiles: [], selectedFiles: [],
            modalInstance: null, deleteModalInstance: null, detailsModalInstance: null,
            itemToDelete: null, isBulkDelete: false, selectedClient: null,
            showOccurrenceForm: false,
            newOccurrence: { type: 'contato', description: '' },
            newFilesPreview: [],
            docIdToDelete: null,
            modalDeleteInstance: null,
            selectedClientGed: null,
            modalGedInstance: null,
            errors: {},
            newGedFiles: [], // Arquivos selecionados no modal de GED
            pagination: {
                current_page: 1, // Sempre inicialize com 1
                last_page: 1
            },
            loadingGed: false,
            uploadStats: {
                total: 0,
                sent: 0,
                percentage: 0,
                currentFileName: ''
            },

            searchingCnpj: false,
            stats: {
                total: 0,
                new_month: 0,
                defaulters: 0,
                total_credit: 0
            },
            loadingReport: false,
            reportModalInstance: null,
            reportFilters: {
                start_date: '',
                end_date: '',
                status: 'ALL',
                person_type: 'ALL',
                state: 'ALL',
                city: 'ALL',
                branch_id: 'ALL',
                // Inicia com alguns campos padrão já selecionados
                fields: ['name', 'document', 'phone', 'city', 'state', 'status',]
            },
            cities: [],
            availableFields: [
                { id: 'name', label: 'Nome/Razão Social' },
                { id: 'document', label: 'CPF/CNPJ' },
                { id: 'phone', label: 'Telefone' },
                { id: 'email', label: 'E-mail' },
                { id: 'status', label: 'Status' },
                { id: 'zip_code', label: 'CEP' },
                { id: 'street', label: 'Rua' },
                { id: 'neighborhood', label: 'Bairro' },
                { id: 'city', label: 'Cidade' },
                { id: 'state', label: 'UF' },
                { id: 'marital_status', label: 'Estado Civil' },
                { id: 'occupation', label: 'Profissão' },
                { id: 'id_document', label: 'RG' },
                { id: 'driver_license', label: 'CNH' },
                { id: 'credit_limit', label: 'Limite de Crédito' },
                { id: 'internal_score', label: 'Score' },
                { id: 'branches', label: 'Empresas' }
            ],
            exportFormat: 'pdf',
            importPreviewData: [],
            importFileObject: null,
            modalImportInstance: null,
            importErrors: [],
            importDuplicates: [],
            showGedPreview: false,
            activeDoc: null,
            clientToReanalyze: null,
            reanalyzeModalInstance: null,
            reanalyzing: false
        }
    },
    watch: {
        'reportFilters.state': function (newUf) {
            this.reportFilters.city = 'ALL';

            if (newUf === 'ALL') {
                this.cities = [];
                return;
            }

            this.fetchCitiesFromIBGE(newUf);
        },
        'filter.score_min'(val) {
            if (val > 1000) this.filter.score_min = 1000;
            if (val < 0) this.filter.score_min = 0;
        },
        'filter.score_max'(val) {
            if (val > 1000) this.filter.score_max = 1000;
            if (val < 0) this.filter.score_max = 0;
        }
    },
    directives: {
        tooltip: {
            mounted(el, binding) {
                new window.bootstrap.Tooltip(el, {
                    title: binding.value,
                    placement: 'top',
                    trigger: 'hover',
                    customClass: 'custom-tooltip-ia' // Classe opcional para estilizar ainda mais
                });
            },
            updated(el, binding) {
                const tooltip = window.bootstrap.Tooltip.getInstance(el);
                if (tooltip) {
                    tooltip.setContent({ '.tooltip-inner': binding.value });
                }
            },
            beforeUnmount(el) {
                const tooltip = window.bootstrap.Tooltip.getInstance(el);
                if (tooltip) {
                    tooltip.dispose();
                }
            }
        }
    },
    computed: {
        isAllSelected() { return this.clients.length > 0 && this.selectedIds.length === this.clients.length; },
        isFormValid() { return this.form.name && this.form.document && this.form.phone; },
        isReportValid() { return this.reportFilters.fields.length >= 2; },
        selectAllFields: {
            get() {
                // Verifica se todos os itens disponíveis estão presentes no array de filtros
                return this.reportFilters.fields.length === this.availableFields.length;
            },
            set(value) {
                if (value) {
                    // Preenche o array com todos os IDs
                    this.reportFilters.fields = this.availableFields.map(f => f.id);
                } else {
                    // Esvazia o array
                    this.reportFilters.fields = [];
                }
            }
        },

        activeSuggestions() {
            const suggestions = this.selectedClient?.data_quality_analysis?.suggestions;
            console.log(suggestions);
            if (!suggestions) return [];
            return Object.keys(suggestions)
                .filter(key => suggestions[key] !== null && suggestions[key] !== '')
                .map(key => ({
                    field: key,
                    text: suggestions[key]
                }));
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initModals();
        });
        this.fetchDashboardStats();
        this.fetchClients();
        this.fetchBranchesList();
    },
    methods: {
        initModals() {
            const modalEl = document.getElementById('modalClient');
            const detailsEl = document.getElementById('modalClientDetails');
            const deleteEl = document.getElementById('confirmDeleteModal');
            const deleteDocEl = document.getElementById('modalDeleteDoc');
            const reportEl = document.getElementById('modalGeneralReport');
            const gedEl = document.getElementById('modalGed');
            const reanalyzeEl = document.getElementById('confirmReanalyzeModal');

            if (modalEl) {
                this.modalInstance = new window.bootstrap.Modal(modalEl);
            }
            if (detailsEl) {
                this.detailsModalInstance = new window.bootstrap.Modal(detailsEl);
            }
            if (deleteEl) {
                this.deleteModalInstance = new window.bootstrap.Modal(deleteEl);
            }

            if (deleteDocEl) {
                this.docDeleteModalInstance = new window.bootstrap.Modal(deleteDocEl);
            }

            if (reportEl) {
                this.reportModalInstance = new window.bootstrap.Modal(reportEl);
            }

            if (gedEl) {
                this.gedModalInstance = new window.bootstrap.Modal(gedEl);
            }

            if (reanalyzeEl) {
                this.reanalyzeModalInstance = new window.bootstrap.Modal(reanalyzeEl);
            }
        },

        async fetchDashboardStats() {
            try {
                const response = await api.get('/clients/dashboard-stats');
                this.stats = response.data;
            } catch (e) {
                console.error("Erro ao carregar dashboard", e);
            }
        },

        async searchExternalCnpj() {
            if (!this.form.document) return;

            this.searchingCnpj = true;
            const cnpjClear = this.form.document ? this.form.document.replace(/\D/g, '') : '';
            try {
                const response = await api.get(`/external/cnpj/${cnpjClear}`);
                const data = response.data;

                // Preenchimento automático dos campos
                this.form.name = data.razao_social;
                this.form.nickname = data.nome_fantasia;
                this.form.zip_code = data.cep;
                this.form.street = data.logradouro;
                this.form.neighborhood = data.bairro;
                this.form.city = data.cidade;
                this.form.state = data.uf;
                this.form.phone = data.telefone;
                this.form.email = data.email;

                this.showAlert("Dados importados com sucesso!");
            } catch (e) {
                const msg = e.response?.data?.message || "CNPJ não encontrado ou erro na API.";
                this.showAlert(msg, "error");
            } finally {
                this.searchingCnpj = false;
            }
        },

        async fetchClients(page = 1, append = false) {
            this.globalLoading.show('Carregando clientes...');
            this.loading = true;
            try {
                const params = {
                    page,
                    search: this.filter.search,
                    branch_id: this.filter.branch_id,
                    score_min: this.filter.score_min,
                    score_max: this.filter.score_max,
                    credit_min: this.filter.credit_min,
                    credit_max: this.filter.credit_max,
                };

                const res = await api.get('/clients', { params });
                const { data, meta } = res.data;
                this.clients = append ? [...this.clients, ...data] : data;
                this.totalItems = meta.total;
                this.currentPage = meta.current_page;
                this.lastPage = meta.last_page;
                this.hasMore = this.currentPage < this.lastPage;
            } catch (e) {
                this.showAlert("Erro ao buscar dados.", "error");
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },
        async fetchBranchesList() {
            try {
                const res = await api.get('/branches', { params: { per_page: 100 } });
                this.branchesList = res.data.data || res.data;
            } catch (e) {
                console.error("Erro ao carregar Empresas para o filtro", e);
            }
        },


        getFileIcon(type) {
            const icons = {
                pdf: 'bi bi-file-earmark-pdf text-danger',
                jpg: 'bi bi-file-earmark-image text-primary',
                jpeg: 'bi bi-file-earmark-image text-primary',
                png: 'bi bi-file-earmark-image text-success',
            };
            return icons[type?.toLowerCase()] || 'bi bi-file-earmark-text';
        },

        openModal(mode, item = null) {
            clientModalState.open(item, () => {
                this.showAlert('Salvo com sucesso!');
                this.fetchClients(1, false);
                this.fetchDashboardStats();
            });
        },

        async directUploadDocument(file, clientId) {
            try {
                const { data } = await api.post(`/clients/${clientId}/documents/upload-link`, {
                    fileName: file.name,
                    mimeType: file.type
                });

                await fetch(data.uploadUrl, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': file.type
                    },
                    body: file
                });

                // Modificação aqui: capturar a resposta do Laravel
                const response = await api.post(`/clients/${clientId}/documents/confirm`, {
                    provider_id: data.providerFileId,
                    file_name: file.name,
                    verify_ia: false
                });

                // Retorna o documento que o Laravel acabou de salvar no banco
                return response.data;

            } catch (e) {
                console.error('Falha no upload direto do arquivo:', file.name, e);
                throw e;
            }
        },

        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            if (this.deleteModalInstance) this.deleteModalInstance.show();
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) await api.post('/clients/bulk-delete', { ids: this.selectedIds });
                else await api.delete(`/clients/${this.itemToDelete.id}`);
                this.showAlert("Excluído com sucesso!", "danger");
                this.selectedIds = [];
                this.fetchClients(1, false);
            } catch (e) { this.showAlert("Erro ao excluir.", "error"); }
            finally { if (this.deleteModalInstance) this.deleteModalInstance.hide(); }
        },

        // Helper Alertas e Miscs
        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';

            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'warning') icon = 'bi-exclamação-triangle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });

            const timeout = type === 'error' ? 6000 : 4000;
            setTimeout(() => this.removeAlert(id), timeout);
        },
        removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },

        async fetchAddressByCep() {
            const cep = this.form.zip_code.replace(/\D/g, '');
            if (cep.length === 8) {
                try {
                    const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                    const d = await r.json();
                    if (!d.erro) {
                        this.form.street = d.logradouro;
                        this.form.neighborhood = d.bairro;
                        this.form.city = d.localidade;
                        this.form.state = d.uf;
                    }
                } catch (e) { console.error(e); }
            }
        },

        applyDocumentMask(e) {
            let v = e.target.value.replace(/\D/g, ""); // Remove tudo que não é dígito
            if (v.length <= 11) {
                // CPF: 000.000.000-00
                v = v.replace(/(\d{3})(\d)/, "$1.$2");
                v = v.replace(/(\d{3})(\d)/, "$1.$2");
                v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            } else {
                // CNPJ: 00.000.000/0000-00
                v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                v = v.replace(/(\d{4})(\d)/, "$1-$2");
            }
            this.form.document = v;
        },
        applyPhoneMask(e) {
            let v = e.target.value.replace(/\D/g, "");

            // Limita a 11 dígitos no total (tamanho máximo que atende Celulares e 0800)
            if (v.length > 11) {
                v = v.substring(0, 11);
            }

            // Verifica se é um número especial (0800 ou 0300)
            if (v.startsWith("0800") || v.startsWith("0300")) {
                if (v.length > 7) {
                    // Formato: 0800 000 0000
                    v = v.replace(/^(\d{4})(\d{3})(\d{0,4}).*/, "$1 $2 $3");
                } else if (v.length > 4) {
                    // Formato: 0800 000...
                    v = v.replace(/^(\d{4})(\d{0,3})/, "$1 $2");
                }
            } else {
                // Formatação Padrão: Fixo e Celular com DDD
                if (v.length > 10) {
                    // Celular: (99) 99999-9999
                    v = v.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
                } else if (v.length > 6) {
                    // Fixo completo: (99) 9999-9999
                    v = v.replace(/^(\d{2})(\d{4})(\d+)/, "($1) $2-$3");
                } else if (v.length > 2) {
                    // Apenas DDD e início do número: (99) 99...
                    v = v.replace(/^(\d{2})(\d+)/, "($1) $2");
                } else if (v.length > 0) {
                    // Apenas dígito inicial do DDD: (9
                    v = v.replace(/^(\d*)/, "($1");
                }
            }

            this.form.phone = v;
        },
        maskCurrency(e) {
            let v = e.target.value.replace(/\D/g, ""); // Remove tudo que não é número

            // Transforma em valor monetário formatado (ex: 125050 -> 1.250,50)
            v = (Number(v) / 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            this.form.credit_limit = v;
        },
        applyCepMask() { this.form.zip_code = this.form.zip_code.replace(/\D/g, '').replace(/^(\d{5})(\d)/, "$1-$2"); },
        handleFileSelection(e) {
            const selectedFiles = Array.from(e.target.files);

            if (!Array.isArray(this.form.documents)) {
                this.form.documents = [];
            }

            this.form.documents = [...this.form.documents, ...selectedFiles];
            this.newFilesPreview = [...this.newFilesPreview, ...selectedFiles];

            e.target.value = '';
        },
        removeNewFile(index) {
            this.form.documents.splice(index, 1);
            this.newFilesPreview.splice(index, 1);
        },
        removeFile(i) { this.clientFiles.splice(i, 1); this.selectedFiles.splice(i, 1); },
        toggleAll(e) { this.selectedIds = e.target.checked ? this.clients.map(c => c.id) : []; },
        applyFilter() { this.showFilter = false; this.fetchClients(1, false); },
        loadMore() { if (this.hasMore) this.fetchClients(this.currentPage + 1, true); },
        openDetails(item) {
            this.selectedClient = item;
            if (this.detailsModalInstance) {
                this.detailsModalInstance.show();
            } else {
                const myModal = new window.bootstrap.Modal(document.getElementById('modalClientDetails'));
                myModal.show();
            }
        },

        formatFieldName(field) {
            const labels = {
                name: 'Nome',
                document: 'Documento',
                email: 'E-mail',
                phone: 'Telefone',
                status: 'Status',
                city: 'Cidade',
                state: 'Estado (UF)',
                notes: 'Observações',
                occupation: 'Ocupação',
                neighborhood: 'Bairro',
                street: 'Rua',
                marital_status: 'Estado Civil',
                zip_code: 'CEP',
                education_level: 'Escolaridade',
                driver_license: 'CNH',
                id_document: 'RG'
            };
            return labels[field] || field.replace('_', ' ');
        },

        getActionClass(action) {
            if (!action) return 'bg-light text-dark border';

            const actionLower = action.toLowerCase();

            if (actionLower === 'created') return 'badge-creation';
            if (actionLower === 'updated') return 'badge-update';
            if (actionLower === 'deleted') return 'badge-deletion';

            return 'bg-light text-dark border';
        },

        async saveOccurrence() {
            if (!this.newOccurrence.description) return;

            try {
                const response = await api.post(`/clients/${this.selectedClient.id}/occurrences`, this.newOccurrence);
                if (!Array.isArray(this.selectedClient.occurrences)) {
                    this.selectedClient.occurrences = [];
                }
                this.selectedClient.occurrences.unshift(response.data);
                this.newOccurrence.description = '';
                this.showOccurrenceForm = false;
                this.showAlert("Interação registrada!");
            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                } else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar contato.", "error");
                }
            }
        },

        cleanPhone(phone) {
            if (!phone) return '';
            return phone.replace(/\D/g, '');
        },

        async downloadFile(doc) {
            try {
                const clientId = this.selectedClientGed.id;

                // Pega a URL assinada devolvida pelo Laravel
                const response = await api.get(`/clients/${clientId}/documents/${doc.id}/download`);
                console.log(response);
                // // Abre em uma nova aba ou força o download via navegador
                window.open(response.data.url, '_blank');

            } catch (error) {
                this.showAlert("Erro ao gerar link de download.", "error");
                console.error(error);
            }
        },
        confirmDeleteDoc(id) {
            this.docIdToDelete = id;
            if (this.docDeleteModalInstance) {
                this.docDeleteModalInstance.show();
            }
        },

        async executeDocDeletion() {
            if (!this.docIdToDelete) return;

            try {
                await api.delete(`/clients/${this.selectedClientGed.id}/documents/${this.docIdToDelete}`);

                if (this.selectedClientGed && Array.isArray(this.selectedClientGed.documents)) {
                    this.selectedClientGed.documents = this.selectedClientGed.documents.filter(
                        doc => doc.id !== this.docIdToDelete
                    );
                }

                if (this.form?.documents_existing) {
                    this.form.documents_existing = this.form.documents_existing.filter(
                        doc => doc.id !== this.docIdToDelete
                    );
                }

                this.showAlert("Documento excluído!");

                if (this.docDeleteModalInstance) {
                    this.docDeleteModalInstance.hide();
                }

                this.docIdToDelete = null;
                this.newGedFiles = [];
                this.fetchClients(this.currentPage || 1, false);

            } catch (e) {
                console.error("Erro ao excluir arquivo:", e);
                this.showAlert("Erro ao remover o arquivo da visualização.", "error");
            }
        },

        async deleteDocument(id) {
            try {
                await api.delete(`/documents/${id}`);
                this.form.documents_existing = this.form.documents_existing.filter(d => d.id !== id);
                this.showAlert("Documento excluído com sucesso!");
            } catch (e) {
                console.error(e);
                this.showAlert("Erro ao tentar excluir o documento.", "error");
            }
        },
        openGedModal(client) {
            this.selectedClientGed = { ...client };
            this.newGedFiles = [];

            if (!this.modalGedInstance) {
                this.modalGedInstance = new window.bootstrap.Modal(document.getElementById('modalGed'));
            }
            this.modalGedInstance.show();
        },

        handleFileSelectionGed(e) {
            const files = Array.from(e.target.files);

            if (files.length > 0) {
                this.newGedFiles = [...this.newGedFiles, ...files];
            }
            e.target.value = '';
        },

        removeNewGedFile(index) {
            this.newGedFiles.splice(index, 1);
        },

        async uploadGedFiles() {
            if (!this.selectedClientGed?.id) return;
            if (!this.newGedFiles.length) return;
            this.loadingGed = true;
            this.uploadStats = {
                total: this.newGedFiles.length,
                sent: 0,
                percentage: 0,
                currentFileName: ''
            };

            try {
                if (!this.selectedClientGed.documents) {
                    this.selectedClientGed.documents = [];
                }

                for (const file of this.newGedFiles) {
                    if (file instanceof File) {
                        this.uploadStats.currentFileName = file.name;
                        const novoDocumento = await this.directUploadDocument(file, this.selectedClientGed.id);
                        const docSalvo = novoDocumento.data || novoDocumento;
                        const docParaInserir = {
                            id: docSalvo.id || Date.now(),
                            file_name: docSalvo.file_name || docSalvo.name || file.name,
                            file_size: docSalvo.file_size || `${(file.size / 1024).toFixed(1)} KB`,
                            file_type: docSalvo.file_type || file.name.split('.').pop().toLowerCase(),
                            url: docSalvo.url || '',
                            ...docSalvo
                        };

                        this.selectedClientGed.documents.push(docParaInserir);

                        this.uploadStats.sent++;
                        this.uploadStats.percentage = Math.round((this.uploadStats.sent / this.uploadStats.total) * 100);
                    }
                }

                this.showAlert("Documentos enviados com sucesso!", "success");
                this.modalGedInstance.hide();
                this.newGedFiles = [];
                this.selectedClientGed = null;
            } catch (e) {
                console.error("Erro no upload:", e);
                this.showAlert("Erro ao enviar arquivos para a nuvem.", "danger");
            } finally {
                this.loadingGed = false;
                setTimeout(() => {
                    this.uploadStats = { total: 0, sent: 0, percentage: 0, currentFileName: '' };
                    window.location.reload();

                }, 1500);
            }
        },

        async refreshGedData(documents) {
            this.selectedClientGed = documents;
            this.fetchClients(this.pagination.current_page, false);
        },
        formatMoney(value) {
            return parseFloat(value || 0).toLocaleString('pt-br', { minimumFractionDigits: 2 });
        },
        openReportModal(format = 'pdf') {
            this.exportFormat = format;
            if (this.reportModalInstance) {
                this.reportModalInstance.show();
            } else {
                const reportEl = document.getElementById('modalGeneralReport');
                if (reportEl) {
                    this.reportModalInstance = new window.bootstrap.Modal(reportEl);
                    this.reportModalInstance.show();
                }
            }
        },
        async downloadGeneralReport() {
            this.loadingReport = true;
            this.globalLoading.show('Gerando PDF...');
            try {
                const filtersToSend = { ...this.reportFilters };
                filtersToSend.fields = filtersToSend.fields.join(',');
                const params = new URLSearchParams(filtersToSend).toString();
                const response = await api.get(`/clients/reports/general?${params}`, { responseType: 'blob' });
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `relatorio_geral_clientes_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                link.remove();
                this.reportModalInstance.hide();
                this.showAlert("Relatório gerado com sucesso!");

            } catch (e) {
                console.error("Erro no relatório:", e);
                this.showAlert("Erro ao processar o arquivo PDF.", "error");
            } finally {
                this.loadingReport = false;
                this.globalLoading.hide();
            }
        },
        async fetchCitiesFromIBGE(uf) {
            this.loadingCities = true;
            try {
                const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
                const data = await response.json();
                this.cities = data;
            } catch (error) {
                console.error("Erro ao carregar cidades do IBGE", error);
                this.showAlert("Não foi possível carregar as cidades.", "error");
            } finally {
                this.loadingCities = false;
            }
        },

        async exportClientsExcel() {
            this.loading = true;
            this.globalLoading.show('Gerando Planilha...');
            try {
                const params = new URLSearchParams(this.reportFilters).toString();

                const response = await api.get(`/clients/export/excel?${params}`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `clientes_rmr_${Date.now()}.xlsx`);
                document.body.appendChild(link);
                link.click();

                link.remove();
                window.URL.revokeObjectURL(url);
                this.showAlert("Planilha gerada com sucesso!");
            } catch (e) {
                console.error(e);
                this.showAlert("Erro ao exportar planilha.", "error");
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        openImportModal() {
            this.resetImport();
            if (!this.modalImportInstance) {
                this.modalImportInstance = new window.bootstrap.Modal(document.getElementById('modalImportPreview'));
            }
            this.modalImportInstance.show();
        },

        resetImport() {
            this.importPreviewData = [];
            this.importFileObject = null;
            if (this.$refs.fileInputImport) this.$refs.fileInputImport.value = '';
        },

        handleFilePreview(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.importFileObject = file;
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rawJson = XLSX.utils.sheet_to_json(worksheet);

                const docCounts = new Map();
                const emailCounts = new Map();

                rawJson.forEach(row => {
                    const doc = row['CPF_CNPJ'] || row['documento'] || row['Documento'];
                    const email = row['E-mail'] || row['email'] || row['Email'];
                    if (doc) docCounts.set(doc, (docCounts.get(doc) || 0) + 1);
                    if (email) emailCounts.set(email, (emailCounts.get(email) || 0) + 1);
                });

                const errors = [];
                const duplicates = [];

                this.importPreviewData = rawJson.map((row, index) => {
                    const excelRow = index + 2;

                    const rowData = {
                        excelRow: excelRow,
                        nome: row['Nome Completo'] || row['Nome_Completo'] || row['nome'] || row['Nome'] || '---',
                        documento: row['CPF_CNPJ'] || row['documento'] || row['Documento'] || '---',
                        email: row['E-mail'] || row['email'] || row['Email'] || '---',
                        telefone: row['Telefone'] || row['telefone'] || '---',
                        cidade: row['Cidade'] || row['cidade'] || '---',
                        uf: row['UF'] || row['uf'] || '--',
                        limite: row['Limite de Crédito'] || row['limite'] || '0,00',
                        score: row['Score'] || row['score'] || '0'
                    };

                    const missingFields = [];
                    const duplicateFields = [];

                    if (rowData.nome === '---') missingFields.push('Nome');
                    if (rowData.documento === '---') missingFields.push('Documento');
                    if (rowData.email === '---') missingFields.push('E-mail');

                    if (rowData.documento !== '---' && docCounts.get(rowData.documento) > 1) duplicateFields.push('Doc Repetido');
                    if (rowData.email !== '---' && emailCounts.get(rowData.email) > 1) duplicateFields.push('E-mail Repetido');

                    if (missingFields.length > 0) {
                        errors.push({ linha: excelRow, campos: missingFields.join(', ') });
                    }
                    if (duplicateFields.length > 0) {
                        duplicates.push({ linha: excelRow, info: duplicateFields.join(' e ') });
                    }

                    rowData.isInvalid = missingFields.length > 0;
                    rowData.isDuplicate = duplicateFields.length > 0;
                    rowData.errorsList = [...missingFields, ...duplicateFields].join(', ');

                    return rowData;
                });

                this.importErrors = errors;
                this.importDuplicates = duplicates;
            };
            reader.readAsArrayBuffer(file);
        },

        async executeFinalImport() {
            if (!this.importFileObject) return;

            this.loading = true;
            const fd = new FormData();
            fd.append('file', this.importFileObject);

            try {
                await api.post('/clients/import', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                this.showAlert("Importação inicializada!");
                this.modalImportInstance.hide();
                this.fetchClients(1, false);
                this.fetchDashboardStats();
            } catch (e) {
                this.showAlert("Erro ao processar arquivo no servidor.", "error");
            } finally {
                this.loading = false;
            }
        },
        downloadImportTemplate() {
            const link = document.createElement('a');
            link.href = '/templates/modelo_importacao_clientes.xlsx';
            link.setAttribute('download', 'modelo_importacao_rmr.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        getQualityBadgeClass(score) {
            if (score >= 0.8) return 'bg-success-subtle text-success border-success';
            if (score >= 0.4) return 'bg-warning-subtle text-warning border-warning';
            return 'bg-danger-subtle text-danger border-danger';
        },

        getQualityColor(score) {
            if (score >= 0.8) return 'success';
            if (score >= 0.5) return 'warning';
            return 'danger';
        },
        async reanalyzeClient() {
            this.reanalyzing = true;
            try {
                await api.post(`/clients/${this.selectedClient.id}/reanalyze`);
                this.showAlert("IA está reavaliando os dados...");
            } catch (e) {
                this.showAlert("Erro ao solicitar análise", "error");
            } finally {
                this.reanalyzing = false;
            }
        },

        isViewable(doc) {
            // Verifica se a extensão é de imagem ou PDF
            const ext = doc.file_type ? doc.file_type.toLowerCase() : doc.url.split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'pdf', 'webp'].includes(ext);
        },
        handleViewOrDownload(doc) {
            if (this.isViewable(doc)) {
                // Abre o arquivo na mesma aba ou nova aba para visualizar
                window.open(doc.url, '_blank');
            } else {
                // Força o download se não for visualizável
                this.downloadFile(doc);
            }
        },

        getFileExtension(url) {
            // Remove tudo após o '?' (parâmetros da AWS)
            const cleanUrl = url.split('?')[0];
            // Pega a extensão após o último ponto
            return cleanUrl.split('.').pop().toLowerCase();
        },

        isImage(doc) {
            const ext = this.getFileExtension(doc.url);
            return ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(ext);
        },

        isPdf(doc) {
            const ext = this.getFileExtension(doc.url);
            return ext === 'pdf';
        },

        getProcessedUrl(doc, action) {
            // Pega a URL bruta que vem do Axios
            let url = doc.url;

            // Remove qualquer tentativa anterior de forçar o download, para garantir que comece limpo
            url = url.replace('response-content-disposition=attachment', '');

            // Se a ação for baixar, adiciona o parâmetro de attachment
            if (action === 'download') {
                url += (url.includes('?') ? '&' : '?') + 'response-content-disposition=attachment';
            }

            return url;
        },

        async viewDocument(doc) {
            try {
                const clientId = this.selectedClientGed.id;

                // Chamamos o mesmo endpoint, mas passamos ?download=false
                const response = await api.get(`/clients/${clientId}/documents/${doc.id}/download?download=false`);


                this.activeDoc = { ...doc, url: response.data.url };
                this.showGedPreview = true;

            } catch (error) {
                this.showAlert("Erro ao gerar link de visualização.", "error");
            }
        },

        getScoreClass(score) {
            if (score <= 40) return 'bg-danger text-white';
            if (score <= 79) return 'bg-warning text-dark';
            return 'bg-success text-white';
        },

        confirmReanalyze(item) {
            this.clientToReanalyze = item;
            if (this.reanalyzeModalInstance) {
                this.reanalyzeModalInstance.show();
            } else {
                const myModal = new window.bootstrap.Modal(document.getElementById('confirmReanalyzeModal'));
                myModal.show();
            }
        },

        async executeReanalyze() {
            if (!this.clientToReanalyze) return;

            this.reanalyzing = true;
            try {
                await api.post(`/clients/${this.clientToReanalyze.id}/reanalyze`);
                this.showAlert("IA está reavaliando os dados...");

                // Esconde o modal
                if (this.reanalyzeModalInstance) {
                    this.reanalyzeModalInstance.hide();
                } else {
                    const modalEl = document.getElementById('confirmReanalyzeModal');
                    const modal = window.bootstrap.Modal.getInstance(modalEl);
                    if (modal) modal.hide();
                }

                // Atualiza a listagem
                this.fetchClients(this.currentPage, false);
            } catch (e) {
                this.showAlert("Erro ao solicitar análise da IA", "error");
            } finally {
                this.reanalyzing = false;
                this.clientToReanalyze = null;
            }
        },
        refreshData() {
            this.fetchClients(1, false);
        },
        maskCurrencyMin(e) {
            let v = e.target.value.replace(/\D/g, "");
            this.filter.credit_min = (Number(v) / 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        maskCurrencyMax(e) {
            let v = e.target.value.replace(/\D/g, "");
            this.filter.credit_max = (Number(v) / 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        clearFilters() {
            this.filter = {
                search: '',
                branch_id: '',
                score_min: '',
                score_max: '',
                credit_min: '',
                credit_max: ''
            };
            this.fetchClients(1, false);
        },

    }
}
</script>

<style scoped>
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

/* Unificando o tamanho e comportamento de todos os botões da RMR */
.btn-pmg-primary,
.btn-pmg-light,
.btn-pmg-danger {
    padding: 10px 24px !important;
    /* Aumentamos um pouco o preenchimento lateral */
    border-radius: 10px;
    font-weight: 500;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    height: 45px;
    /* Fixamos a altura para garantir simetria total */
}

/* Cores específicas para o Primary */
.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
}

.btn-pmg-primary:hover {
    background: #1a294d;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(33, 51, 97, 0.2);
}

/* Cores específicas para o Light */
.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
}

.btn-pmg-light:hover {
    background-color: #f8fafc;
    color: #1e293b;
    border-color: #cbd5e1;
}

/* Cores específicas para o Danger */
.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
}

.form-control-pmg {
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding: 10px 14px;
}

.nav-tabs-pmg .nav-link.active {
    color: #561569;
    border-bottom: 3px solid #561569;
    background: transparent;
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.pointer {
    cursor: pointer;
}

.tiny {
    font-size: 0.7rem;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

/* TABS ESTILO PRODUTO (REVISADO) */
.nav-tabs-pmg {
    border-bottom: 1px solid #e2e8f0;
    gap: 2rem;
    border-top: none;
    border-left: none;
    border-right: none;
}

.nav-tabs-pmg .nav-link {
    border: none !important;
    color: #94a3b8 !important;
    font-weight: 600;
    padding: 0.5rem 0;
    background: transparent !important;
    font-size: 0.95rem;
    transition: color 0.2s ease;
}

.nav-tabs-pmg .nav-link.active {
    color: #561569 !important;
    border-bottom: 3px solid #561569 !important;
    background: transparent !important;
}

.nav-tabs-pmg .nav-link:hover:not(.active) {
    color: #64748b !important;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.timeline-item {
    position: relative;
    padding-bottom: 1.5rem;
}

.bg-secondary-subtle {
    background-color: #f1f5f9 !important;
    color: #475569 !important;
    font-size: 0.65rem !important;
    letter-spacing: 0.5px;
}

.border-light-subtle {
    border-color: #e2e8f0 !important;
}

.tiny {
    font-size: 0.75rem;
}

/* Container da Timeline */
.audit-timeline {
    position: relative;
    border-left: 2px solid #e2e8f0;
    margin-left: 10px;
    padding-left: 20px !important;
}

/* Item da Auditoria */
.audit-item {
    position: relative;
}

.audit-item::before {
    content: '';
    position: absolute;
    left: -26px;
    top: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #561569;
}

/* Badges de Ação */
.badge-action {
    font-size: 0.65rem;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 800;
    letter-spacing: 0.5px;
}

.badge-creation {
    background: #dcfce7;
    color: #15803d;
}

.badge-update {
    background: #eff6ff;
    color: #1d4ed8;
}

.badge-deletion {
    background: #fee2e2;
    color: #b91c1c;
}

/* Card de Mudanças */
.audit-changes-card {
    background-color: #f8fafc;
    border-radius: 12px;
    padding: 1rem;
    border: 1px solid #f1f5f9;
}

.change-row {
    padding: 8px 0;
    border-bottom: 1px solid #edf2f7;
}

.change-row:last-child {
    border-bottom: none;
}

.change-label {
    font-size: 0.65rem;
    color: #64748b;
    font-weight: 700;
    margin-bottom: 2px;
}

.old-value,
.new-value {
    font-size: 0.85rem;
}

.line-height-1 {
    line-height: 1.2;
}

#modalDeleteDoc {
    z-index: 1080 !important;
}

#modalDeleteDoc~.modal-backdrop {
    z-index: 1070 !important;
}

.bg-pmg-light {
    background-color: rgba(13, 110, 253, 0.1);
}

.bg-success-light {
    background-color: rgba(25, 135, 84, 0.1);
}

.bg-danger-light {
    background-color: rgba(220, 53, 69, 0.1);
}

.bg-warning-light {
    background-color: rgba(255, 193, 7, 0.1);
}

.table-danger-light {
    background-color: rgba(220, 53, 69, 0.05) !important;
}


.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

:deep(.tooltip-inner) {
    background-color: #1e293b;
    font-size: 0.75rem;
    padding: 8px 12px;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

:deep(.bs-tooltip-top .tooltip-arrow::before) {
    border-top-color: #1e293b;
}

.upload-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    /* Tela escura */
    backdrop-filter: blur(4px);
    /* Efeito de desfoque moderno */
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-card {
    width: 100%;
    max-width: 450px;
    border: none;
    animation: slideUp 0.3s ease-out;
}

.spinner-growth {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 5px;
    display: inline-block;
    vertical-align: -0.125em;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    animation: 0.75s linear infinite spinner-grow;
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes spinner-grow {
    0% {
        transform: scale(0);
    }

    50% {
        opacity: 1;
        transform: none;
    }
}

.progress-bar {
    transition: width 0.4s ease;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
}

.dropdown-menu {
    z-index: 1050 !important;
}

.table-responsive {
    overflow: visible !important;
}
</style>